$(function () {
    $('.l-articles')
        .on('click', '.js-articles-menu', function() {
            var $nav = $('.js-articles-nav');

            $nav.slideToggle(250);
        });
});
